import { useState, useEffect } from 'react';
import axios from 'axios';
const T = { bg:'#f0f5e8', cream:'#fffef0', greenDk:'#1b5e20', maroon:'#6d1b1b', orange:'#e65100', border:'#c8e6c9', header:'linear-gradient(135deg,#090b72,#1a237e)' };
const rahuK = ['4:30-6:00 PM','7:30-9:00 AM','3:00-4:30 PM','12:00-1:30 PM','1:30-3:00 PM','10:30-12:00 PM','9:00-10:30 AM'];
const yamaK = ['12:00-1:30 PM','10:30-12:00 PM','9:00-10:30 AM','7:30-9:00 AM','6:00-7:30 AM','3:00-4:30 PM','1:30-3:00 PM'];
const tDays = ['ஞாயிறு','திங்கள்','செவ்வாய்','புதன்','வியாழன்','வெள்ளி','சனி'];

const PanchangamNextPage = () => {
  const [data, setData] = useState([]);
  useEffect(() => {
    axios.get('/data/panchangam_data-2025-to-2028.json').then(r => {
      const now = new Date(); now.setHours(0,0,0,0);
      const next7 = [];
      for (let i = 1; i <= 7; i++) {
        const d = new Date(now); d.setDate(d.getDate() + i);
        const key = `${d.getMonth()+1}/${d.getDate()}/${d.getFullYear()}`;
        const pd = r.data.find(x => x.EnglishDate === key);
        if (pd) next7.push({ ...pd, dateObj: d });
      }
      setData(next7);
    }).catch(() => {});
  }, []);

  const fmt = v => v != null ? Number(v).toFixed(2) : '';

  return (
    <div style={{background:T.bg,minHeight:'80vh',padding:'10px'}}>
      <div style={{background:T.header,padding:'12px',borderRadius:'10px',textAlign:'center',marginBottom:'10px'}}>
        <h1 style={{color:'#fff',margin:0,fontSize:'1rem',fontWeight:900}}>📅 அடுத்த 7 நாட்கள்</h1>
        <div style={{color:'#c8e6c9',fontSize:'0.7rem'}}>Next 7 Days Panchangam</div>
      </div>
      {data.map((d,i) => {
        const day = d.dateObj.getDay();
        return (
          <div key={i} style={{background:T.cream,borderRadius:'8px',padding:'10px',marginBottom:'6px',border:'1px solid '+T.border}}>
            <div style={{display:'flex',justifyContent:'space-between',marginBottom:'4px'}}>
              <span style={{fontWeight:900,color:T.greenDk,fontSize:'0.85rem'}}>{d.EnglishDate} — {tDays[day]}</span>
              <span style={{fontSize:'0.65rem',color:T.maroon}}>{d.TamilMonth}-{d.TamilDate}</span>
            </div>
            <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:'4px',fontSize:'0.65rem'}}>
              <div>🌙 {d.ThithiNameInTamil}</div>
              <div>⭐ {d.NakshatraNameInTamil}</div>
              <div>🔄 {d.YogaNameInTamil}</div>
              <div>📐 {d.KaranamNameInTamil}</div>
              <div>☀️ உதயம்: {fmt(d.SuryaUdhayam)}</div>
              <div>🌅 அஸ்தமனம்: {fmt(d.SuryaAsthamanam)}</div>
              <div style={{color:'#c62828'}}>🔴 ராகு: {rahuK[day]}</div>
              <div style={{color:T.orange}}>🟡 எமகண்டம்: {yamaK[day]}</div>
            </div>
            {d.DaySpecialityInTamil && <div style={{marginTop:'4px',fontSize:'0.7rem',color:T.orange,fontWeight:700}}>⭐ {d.DaySpecialityInTamil}</div>}
          </div>
        );
      })}
    </div>
  );
};
export default PanchangamNextPage;